<template>
  <div class="step temperature-opening step--temperature-opening heating">
    <div class="temperature-opening__title text-shadow" v-html="$t('temperature.title')"></div>
    <div class="temperature-opening__text" v-html="$t('temperature.text')"></div>

    <div class="conditioning__controls temperature-opening__controls">
      <div class="conditioning__image temperature-opening__image">
        <img src="@/assets/img/stylish.png" alt="stylish condition">
      </div>

      <div class="conditioning__control temperature-opening__control">
        <img class="image-rendering-contrast" src="@/assets/img/modes/heating.png" alt="heating mode">
      </div>
    </div>

    <Button classes="button--small" @click="next()">{{ $t('temperature.button') }}</Button>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import Button from '@/components/global/Button'
import ObjThreeModelSingleton from '../../3d/core/ObjThreeModelSingleton'

export default {
  name: 'StepTemperature',
  props: {},

  components: {
    Button,
  },

  data () {
    return {}
  },

  mounted () {
    this.$store.commit('setModel', 0)

    let model = ObjThreeModelSingleton.getInstance()

    model.satellite.position.x = 20 * model.qualityCoef
    model.satellite.position.y = -8 * model.qualityCoef
    model.satellite.position.z = 20 * model.qualityCoef

    model.satellite2.position.x = 22 * model.qualityCoef
    model.satellite2.position.z = 22 * model.qualityCoef

    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    next () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-next',
          'analytics_label': this.$store.state.step,
        })
      }

      this.$emit('next')
    },
  },

  watch: {},

  computed: {
    ...mapState({
      step: state => state.step,
    }),
  },
}
</script>

<style lang="scss" scoped>

</style>
